<script setup>
    import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableSingle from "@/Components/TableSingle.vue";
    
    defineProps({
        classrooms: Array,
        //select_classroom: Array
        select_level: Array,
        select_modular_code: Array,
        param: Object
    });
    const rutaprefijo = ref('classroom');
    const modulo = ref('Aula');
</script>

<template>
    <Head title="Aulas Configuración" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Aulas/Secciones" />
        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        
                        <div class="w-full overflow-x-auto">
                            <CardBox class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                                <TableSingle :modulo="modulo" :data="classrooms" :select1="select_level" :select2="select_modular_code" :ruta="rutaprefijo" :param="param"/>
                            </CardBox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
